import React, {Component} from 'react';
import $ from 'jquery';
import {showPreloader, hidePreloader, setUrlSinglePageApp} from "../functions";
import {withRouter} from "react-router";

class ImportantInformationPage extends Component {
    state = {posts: []};
    constructor(props) {
        super(props);
        showPreloader();

        setUrlSinglePageApp(this.props.history.location.pathname);
    }
    componentDidMount() {
        this.getPages();
    }

    getPages() {
        let t = this;
        $.ajax({
            url: bm_ajax_url,
            type: 'POST',
            data: {action: 'api/booking/important_information'},
            cache: false,
            dataType: 'json',
            success: function (response, status, jqXHR) {
                hidePreloader();
                if (Array.isArray(response) && response.length > 0) {
                    t.setState({posts: response})
                }
            },
            error: function (jqXHR, status, errorThrown) {
                if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
                    var error = new Error('error: ' + status);
                    Bugsnag.notify(error);
                }
                console.log('error: ' + status);
                hidePreloader();
            }
        });
    }

    render() {
        return (
            <div className="value-space">
                <div className="row">
                    <div className="offset-1 col-10 mt-5">
                        <div className="accordion vertical">
                            <ul>

                                {this.state.posts.map((item, i)=> {
                                    return (
                                        <li key={i}>
                                            <input type="checkbox" id={"radio-"+i} name="radio-accordion"/>
                                            <label htmlFor={"radio-"+i} dangerouslySetInnerHTML={{__html:item.title}} />
                                            <div className="content" dangerouslySetInnerHTML={{__html:item.content}} />
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const ImportantInformationPageR = withRouter(ImportantInformationPage);
export default ImportantInformationPageR;
